export class Animate {

    public animateStyle: string = 'fade-up';
    public animationDelay: string = '500';
    public viewThreshold: string = '20';
    public animateComponents: string;
    public abortCondition: string;
    public animatePagesOnce: boolean;

    private settings = {
        animationDelay: 0,
        viewThreshold: 0
    };

    run() {
        if (this.animatePagesOnce) {
            const hasAnimated = this.checkSessionForAlreadyAnimatedPage();

            if (!hasAnimated) {
                document.body.classList.add('animate-session-show');
                this.setup();
            } else {
                document.body.classList.add('animate-session-abort');
            }
        } else {
            this.setup();
        }
    }

    setup() {
        if (window.innerWidth > 1024 && !document.querySelector(this.abortCondition)) {

            this.setInitialStyles();
            let appLoadWatch: any = null;

            setTimeout(() => {
                this.setAnimations();
            }, 500);

            this.settings.animationDelay = parseInt(this.animationDelay, 10);
            this.settings.viewThreshold = parseInt(this.viewThreshold, 10);
        } else {
            document.body.classList.add('animate-session-abort');
        }
    }

    /**
     * Check session storage to see if this page has already been animated.
     * Set a flag so we dont show animations to user again.
     */
    checkSessionForAlreadyAnimatedPage() {
        let hasAnimated = false;
        const pageHasAlreadyAnimated = window.sessionStorage.getItem('animated-' + window.location.href);

        if (pageHasAlreadyAnimated) {
            hasAnimated = true;
        }

        return hasAnimated;
    }

    /**
     * Set initial styles ot hide elements to be transitioned in.
     * Set appropriate animate style class on body.
     */
    setInitialStyles() {
        let css = '';

        if (this.animateStyle == 'fade-up') {
            css = 'opacity: 0; transform: translateY(25px);';
            document.head.insertAdjacentHTML("beforeend", `<style>
          ${this.animateComponents} {${css}}
        </style>`);
        }

        if (this.animateStyle == 'fade-in') {
            css = 'opacity: 0;';
            document.head.insertAdjacentHTML("beforeend", `<style>
          ${this.animateComponents} {${css}}
        </style>`);
        }

        if (this.animateStyle == 'fade-side') {
            css = 'opacity: 0;';
            document.head.insertAdjacentHTML("beforeend", `<style>
          ${this.animateComponents} {${css}}
        </style>`);
        }

        document.body.classList.add('kdx-animate-' + this.animateStyle);
    }

    /**
     * Set animations for each specific component tag
     */
    setAnimations() {
        const tags = this.animateComponents.split(',');

        tags.forEach((tag) => {
            this.queryContainerForTags(tag)
        });

        if (this.animatePagesOnce) {
            window.sessionStorage.setItem('animated-' + window.location.href, 'true');
        }
    }

    /**
     * Query containers on the page for an intended to animate tag.
     */
    queryContainerForTags(tag) {
        document.querySelectorAll('.content-section, .hero, .quote, .container').forEach((container) => {
            const groupTags = container.querySelectorAll(tag);

            if (groupTags.length) {
                this.setAnimationForTag(container, groupTags);
            }
        });
    }

    /**
     * Watch to see if user as scrolled the intended to animate tags into view.
     * If so, trigger animation function.
     */
    setAnimationForTag(container, components) {
        let shown = false;
        let threshold = this.settings.viewThreshold;

        if (window.innerWidth <= 991) {
            threshold = 0;
        }

        window.addEventListener('scroll', () => {
            if (!shown && isScrolledIntoView(container, threshold)) {
                this.animateIn(components);
                shown = true;
            }
        });

        if (!shown && isScrolledIntoView(container, threshold)) {
            this.animateIn(components);
            shown = true;
        }
    }

    /**
     * Add an animate class to each component with delay to show in order.
     */
    animateIn(components) {
        let delay = this.settings.animationDelay;

        if (components.length >= 8) {
            delay = delay * .25;
        } else if (components.length >= 6) {
            delay = delay * .5;
        } else if (components.length >= 4) {
            delay = delay * .75;
        }

        components.forEach((component: HTMLElement, index) => {
            const isEven = index % 2 == 0;
            setTimeout(() => {
                component.classList.add('kdx-animate-in');

                if (this.animateStyle == 'fade-side') {
                    component.classList.add(isEven ? 'even' : 'odd');
                }
            }, delay * index)
        });
    }

}

function isScrolledIntoView(elm, threshold, mode = 'visible') {
    threshold = threshold || 0;
    mode = mode || 'visible';

    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    var above = rect.bottom - threshold < 0;
    var below = rect.top - viewHeight + threshold >= 0;

    return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
}
